module.exports = __webpack_public_path__ + "static/media/faq-why-nect.8b34d534.svg";